function Check(checkId, customerId, type, status, name, total, notes, openedDate) {

  this.checkId = checkId;
  this.customerId = customerId;
  this.type = type;
  this.status = status;
  this.name = name;
  this.total = total;
  this.notes = notes;
  this.openedDate = openedDate;
  this.closedDate = null;
  this.discount = 0;

  this.checkDetails = {};

}

Check.prototype.createCheckOnApi = function(api) {
  return new Promise ( function (resolve, reject) {
    let postCheckString = api.base_url + 'checks?key=' + api.api +
      '&customerId=' + this.customerId + //set to 0 until customer created (at checkout) unless customer is logged in and has ID
      '&type=' + this.type + //2 - Event check
      '&status=' + this.status +//0 - open
      '&name=' + this.name +
      '&openedDate=' + this.openedDate +
      '&userId=2' + //web user
      '&total=' + this.total +  //total cannot be applied this way unfortunately
      '&discount=' + this.discount +
      '&notes=' + this.notes;

    console.log(postCheckString);

    fetch(postCheckString, {method: 'POST'})
      .then( response => {
        if( !response.ok ){
          throw Error(response.statusText);
        }
        return response;
      })
      .then( response =>
        response.json()
      )
      .then( newCheckId => {
        resolve(newCheckId.checkId); //comes back as an object!!!
      })
      .catch( err => {
        reject(err);
      })
  }.bind(this))
}

Check.prototype.voidCheck = function( api ) {
  return new Promise( function (resolve, reject) {
    let voidCheckString = api.base_url + 'checks/' + this.checkId + '/void?key=' + api.api;

    fetch( voidCheckString, {method: 'POST'})
      .then( response => {
        if( !response.ok ){
          throw Error(response.statusText);
        }
        return response;
      })
      .then( response => {
        resolve(true)
      })
      .catch( err => {
        reject(err);
      })

  }.bind(this));
}

export default Check;
